<template>
  <div class="view view-product inner-width">
    <section>
      <article>
        <h1>{{ title }}</h1>
        <img :src="`${ image.secure_url }`" alt="">
        <div v-html="bodyHtml"></div>
      </article>
      <aside>
        <ComponentProductsList :links="links" :active="activeProduct" />
      </aside>
    </section>
  </div>
</template>


<script>
import { baseCmsUrl, baseCmsNode } from '../../config';
import ComponentProductsList from '@/components/ComponentProductsList.vue';

export default {
  name: 'product',
  components: {
    ComponentProductsList
  },
  props: ['product'],
  data() {
    return {
      title: '',
      image: '',
      bodyHtml: '',
      links: [],
      activeProduct: this.$props.product,
    }
  },
  mounted() {
    this.$http.get(`${baseCmsUrl}node/${baseCmsNode}children?depth=2`).then((response) => {
      var node_id = response.data[1].node_id;

      this.$http.get(`${baseCmsUrl}layout/path/${node_id}/${this.$props.product}`).then((response) => {
        this.title = response.data.main[1].content.fields.title.text;
        this.image = response.data.main[1].content.fields.image;
        this.bodyHtml = response.data.main[1].content.fields.body.content;
        console.log('b: ', response.data.main[1]);
        this.links = response.data.main[0].collection_items;
        return;
      });
/*
      this.$http.get(`${baseCmsUrl}path/${response.data[1].node_id}/${this.$props.product}`).then((response) => {
        console.log('img: ', response.data.fields);
        this.title = response.data.fields.title.text;
        this.image = response.data.fields.image.secure_url;
        this.bodyHtml =  response.data.fields.body.content;
        return;
      });
    */
      return;
    });
  }
} 
</script>
